export const rptByList = [
  { label: 'Inward', value: 'I' },
  { label: 'Outward', value: 'O' }
]

export const rptByWkStatList = [
  { label: 'Accounts Department', value: 'A' },
  { label: 'Claim Department', value: 'C' },
  { label: 'RI Department', value: 'R' },
  { label: 'Underwriting Department', value: 'U' }
]
